export default __webpack_public_path__ + "static/media/livetv.ffe4f1d1.svg";